// extracted by mini-css-extract-plugin
module.exports = {"Scoreboard__Table":"Scoreboard_Scoreboard__Table__17dsp"};